import { NewsOverviewPage } from "@/components/pages/blogOverview/BlogOverview.page";
import { type PreviewType } from "@/pages/api/preview";
import { getAllNewsArticles } from "@/services/content/getAllNewsArticles";
import { getCommonProps, type GetCommonPropsResult } from "@/services/content/getCommonProps";
import { getNewsOverviewPage, type GetNewsOverviewPageResult } from "@/services/content/getNewsOverviewPage";
import { type IGenNewsArticle } from "@/services/graphql/__generated/sdk";

import { type GetStaticProps } from "next";
import React, { type FunctionComponent } from "react";

export type GetNewsOverviewPagePropsResult = { readonly newsArticles: IGenNewsArticle[]} & GetCommonPropsResult & GetNewsOverviewPageResult;

export const getStaticProps: GetStaticProps<GetNewsOverviewPagePropsResult> = async ({ draftMode, locale = "de" }) =>
{
  const previewMode: PreviewType = draftMode ? "draft" : "published";
  const allNewsArticles = await getAllNewsArticles(previewMode, locale);
  const commonProps = await getCommonProps({ locale, previewMode });
  const newsOverviewPageProps = await getNewsOverviewPage(locale, previewMode);

  if(newsOverviewPageProps.resultType === "notFound")
  {
    return {
      notFound: true,
      revalidate: false,
    };
  }

  return {
    props: {
      newsArticles: allNewsArticles,
      ...newsOverviewPageProps,
      ...commonProps,
    },
    revalidate: 1,
  };
};

const NextjsPage: FunctionComponent<GetNewsOverviewPagePropsResult> = props =>
{
  return <NewsOverviewPage {...props}/>;
};

export default NextjsPage;
